const valToGray = v => `rgb(${Math.round((v/50)*255)},${Math.round((v/50)*255)},${Math.round((v/50)*255)})`;


    
    // Helper function to convert HSL to hex
    function hslToHex(h, s, l) {
        s /= 100;
        l /= 100;
    
        const c = (1 - Math.abs(2 * l - 1)) * s;
        const x = c * (1 - Math.abs((h / 60) % 2 - 1));
        const m = l - c / 2;
        let r = 0, g = 0, b = 0;
    
        if (0 <= h && h < 60) {
            r = c; g = x; b = 0;
        } else if (60 <= h && h < 120) {
            r = x; g = c; b = 0;
        } else if (120 <= h && h < 180) {
            r = 0; g = c; b = x;
        } else if (180 <= h && h < 240) {
            r = 0; g = x; b = c;
        } else if (240 <= h && h < 300) {
            r = x; g = 0; b = c;
        } else if (300 <= h && h < 360) {
            r = c; g = 0; b = x;
        }
    
        r = Math.round((r + m) * 255);
        g = Math.round((g + m) * 255);
        b = Math.round((b + m) * 255);
        // console.log("HSL");
        // console.log(`h: ${h}, s: ${s * 100}, l: ${l * 100}, r: ${r}, g: ${g}, b: ${b}`);
        return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()}`;
    }
    function generateBrightColors(colors, step = 0) {
        // Initialize the distributedColors object only once
        // console.log(colors);
        var n = Object.keys(colors).length;
        let distributedColors = [];
    
        for (const [course, colorValue] of Object.entries(colors)) {
            // Calculate hue by dividing the color wheel (360°) by the number of colors
            // console.log("step" + step);
            // console.log("n" + n);
            const hue = Number((step * (360 / n)) % 360);
            // console.log("h:"+hue);
            const saturationOptions = [40, 55, 70, 85];
            const lightnessOptions = [50, 60, 70];
            const saturation = saturationOptions[Math.floor(Math.random() * saturationOptions.length)];
            const lightness = lightnessOptions[Math.floor(Math.random() * lightnessOptions.length)];
    

    
            // Convert HSL to an RGB hex color
            const color = hslToHex(hue, saturation, lightness);
            distributedColors[course] = color;
    
            // Increment the step for the next color
            step++;
        }
        // console.log('Distributed Colors:');
        // console.log(distributedColors);
        return distributedColors;
    }

export { valToGray, generateBrightColors };